import { SEND_EMAIL } from './constants'

export const sendEmail = {
  request: (to, body) => ({ type: SEND_EMAIL.REQUEST, to, body }),
  success: () => ({ type: SEND_EMAIL.SUCCESS }),
  failure: () => ({ type: SEND_EMAIL.FAILURE })
}
